import styled from "@emotion/styled";

import PinnedViewsList from "components/notice_lists/views_bar/PinnedViewsList";
import { SavedViewDataTypeUnion } from "lib/types/savedViews";
import { BasicView } from "../SavedViewsMenu";
import ViewAllButton from "../ViewAllButton";

type PinnedViewsProps = {
  dataType: SavedViewDataTypeUnion;
  pinnedViews: BasicView[];
  setSelectedView: (viewId?: string, viewName?: string, context?: string) => void;
};

function PinnedViews({ dataType, pinnedViews, setSelectedView }: PinnedViewsProps) {
  return (
    <PinnedViewsWrapper>
      <PinnedViewsListScroll>
        <PinnedViewsList pinnedViews={pinnedViews} setSelectedView={setSelectedView} />
      </PinnedViewsListScroll>
      <ViewAllButton filters={{ dataTypes: [dataType] }} fullWidth />
    </PinnedViewsWrapper>
  );
}

const PinnedViewsWrapper = styled.div({
  display: "flex",
  flexDirection: "column",
  height: "100%",
  backgroundColor: "white",
  paddingTop: 8,
  width: "100%",
  paddingLeft: "8px",
});

const PinnedViewsListScroll = styled.div({
  flex: 1,
  overflowY: "auto",
});

export default PinnedViews;
